import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { personalInfoQueryOptions } from '@/hooks/api/personal-info.hooks';
import { api, type UsernameAlias } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';
import { useQueryClient } from '@tanstack/react-query';
import { loginOptionsQueryOptions } from '../../../../../-hooks/login-options.hook';

type ContactType = 'Sms' | 'Email';

interface UseUpdateLoginOptionsConfig {
  onSuccess?: () => void;
  onError?: () => void;
}

export function useUpdateLoginOptions({ onSuccess, onError }: UseUpdateLoginOptionsConfig = {}) {
  const toast = useToast();
  const { t } = useI18n();
  const queryClient = useQueryClient();

  return useNosIdMutation({
    mutationFn: ({
      aliases,
      securityCodes,
    }: {
      aliases: UsernameAlias[];
      securityCodes: Array<{ TargetId: string; Type: ContactType; Code: string }>;
    }) =>
      api.put('/api/v1/personal-info/username-aliases', {
        UsernameAliases: aliases,
        SecurityCodes: securityCodes,
      }),
    successLogAction: () => ({ ActionType: ActionType.Submit, Option: 'LoginOptions' }),
    errorLogAction: () => ({ ActionType: ActionType.Submit, Option: 'LoginOptions' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: personalInfoQueryOptions.queryKey });
      queryClient.invalidateQueries({ queryKey: loginOptionsQueryOptions.queryKey });
      toast.show('success', t('Common.SnackBar.ContactUpdated'));
      onSuccess?.();
    },
    onError,
  });
}
